import React from "react";

/**
 * MAGIS Company logo — stylized SVG approximation of the brand mark.
 * Wordmark "MAGiS Company" + staggered dot cluster on the right.
 */
export const Logo = ({ variant = "light", className = "" }) => {
  const textColor = variant === "light" ? "#FFFFFF" : "#0A2427";
  const subColor = variant === "light" ? "rgba(255,255,255,0.78)" : "rgba(10,36,39,0.7)";
  const dotColor = variant === "light" ? "#FFFFFF" : "#0A2427";
  const accent = "#2EC4B6";

  // 4-row staggered dot cluster, sizes growing left → right
  const cluster = [];
  for (let r = 0; r < 4; r++) {
    for (let c = 0; c < 6; c++) {
      const skip = (r === 0 && c === 5) || (r === 3 && c === 0) || (r === 1 && c === 0);
      if (skip) continue;
      const x = 4 + c * 5 + (r % 2) * 1.5;
      const y = 4 + r * 5;
      const size = 0.7 + (c / 5) * 1.5;
      const isAccent = (r + c) % 7 === 3;
      cluster.push({ x, y, r: size, color: isAccent ? accent : dotColor, op: 0.55 + (c / 6) * 0.45 });
    }
  }

  return (
    <div
      className={`flex items-center gap-3 ${className}`}
      data-testid="magis-logo"
    >
      <div className="flex items-baseline gap-2">
        <span
          className="font-display tracking-tight leading-none"
          style={{
            color: textColor,
            fontSize: 24,
            fontWeight: 800,
            letterSpacing: "-0.02em",
          }}
        >
          MAG<span style={{ fontWeight: 800 }}>i</span>S
        </span>
        <span
          className="font-body tracking-tight leading-none"
          style={{
            color: subColor,
            fontSize: 11,
            fontWeight: 500,
            letterSpacing: "0.02em",
          }}
        >
          Company
        </span>
      </div>

      {/* dot cluster */}
      <svg
        width="42"
        height="24"
        viewBox="0 0 38 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="block"
      >
        {cluster.map((d, i) => (
          <circle key={i} cx={d.x} cy={d.y} r={d.r} fill={d.color} opacity={d.op} />
        ))}
      </svg>
    </div>
  );
};

export default Logo;
